'use client';

import React from 'react';
import MetricCard from '@/components/ui/MetricCard';

const kpis = [
  {
    id: 'kpi-active-bvos',
    label: 'Active BVOs',
    value: '14',
    subValue: '3 added this month',
    trend: 27,
    trendLabel: 'vs last month',
    icon: 'CubeIcon',
    iconColor: 'text-primary',
    variant: 'default' as const,
  },
  {
    id: 'kpi-health-score',
    label: 'Overall Health Score',
    value: '73',
    subValue: 'Composite across all BVOs',
    trend: -4,
    trendLabel: 'vs last week',
    icon: 'HeartIcon',
    iconColor: 'text-warning',
    variant: 'warning' as const,
  },
  {
    id: 'kpi-open-risks',
    label: 'Open Risks',
    value: '11',
    subValue: '4 high severity · 7 medium',
    trend: 38,
    trendLabel: 'vs last week',
    icon: 'ExclamationTriangleIcon',
    iconColor: 'text-negative',
    variant: 'danger' as const,
  },
  {
    id: 'kpi-improvements',
    label: 'Improvement Opportunities',
    value: '28',
    subValue: '9 actioned this quarter',
    trend: 12,
    trendLabel: 'vs last month',
    icon: 'SparklesIcon',
    iconColor: 'text-accent',
    variant: 'default' as const,
  },
];

export default function BentoKPIs() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-4 gap-4">
      {kpis.map((kpi) => (
        <MetricCard key={kpi.id} {...kpi} />
      ))}
    </div>
  );
}